import { Record } from 'immutable';

const OnlineHomeworkRecord = Record({
  lessonNumber: undefined,
  sessionId: undefined,
  unitId: undefined,
  unitOrderingSequence: undefined,
  onlineHomeworkKey: undefined,
  studentOnlineHomeworkResults: undefined,
});

class OnlineHomework extends OnlineHomeworkRecord { }

export default OnlineHomework;



// WEBPACK FOOTER //
// ./data/OnlineHomework/model.js